module.exports = "/virtual-football/img/video/vvb-body-bot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/vvb-body-bot.png
// module id = 314
// module chunks = 6